export default __webpack_public_path__ + "static/media/logo.beb19e08.png";